import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import BackButton from '../components/BackButton';
import Icon from '../components/Icon';
import './styles/ContactScreen.css';

const ContactScreen = () => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSending(true);

    try {
      const res = await fetch('https://63x07bcs81.execute-api.us-east-1.amazonaws.com/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, phone, message }),
      });

      if (!res.ok) throw new Error('Failed to send');
      setSent(true);
      setName('');
      setEmail('');
      setPhone('');
      setMessage('');
    } catch {
      const subject = encodeURIComponent(`Feedback from ${name || 'Anonymous'}`);
      const body = encodeURIComponent(
        `Name: ${name}\nEmail: ${email}\nPhone: ${phone}\n\n${message}`
      );
      window.location.href = `mailto:hello@ykitesti.fi?subject=${subject}&body=${body}`;
      setSent(true);
      setName('');
      setEmail('');
      setPhone('');
      setMessage('');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-container">
      <Helmet>
        <title>Contact Us | YKI Testi</title>
        <meta name="description" content="Get in touch with the YKI Testi team. Send us a message with questions, feedback or suggestions about our free Finnish language test practice app." />
        <link rel="canonical" href="https://ykitesti.fi/contact" />
      </Helmet>
      <BackButton label="Back" />
      <h2 className="contact-title">{t('contactUs')}</h2>
      <p className="contact-desc">{t('contactDescription')}</p>

      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="contact-field">
          <label className="contact-label" htmlFor="contact-name">{t('yourName')}</label>
          <input
            id="contact-name"
            className="contact-input"
            type="text"
            placeholder={t('namePlaceholder')}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="contact-field">
          <label className="contact-label" htmlFor="contact-email">{t('yourEmail')} *</label>
          <input
            id="contact-email"
            className="contact-input"
            type="email"
            placeholder={t('emailPlaceholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="contact-field">
          <label className="contact-label" htmlFor="contact-phone">{t('yourPhone')}</label>
          <input
            id="contact-phone"
            className="contact-input"
            type="tel"
            placeholder={t('phonePlaceholder')}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        <div className="contact-field">
          <label className="contact-label" htmlFor="contact-message">{t('yourMessage')} *</label>
          <textarea
            id="contact-message"
            className="contact-textarea"
            placeholder={t('messagePlaceholder')}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
            required
          />
        </div>

        {error && <p className="contact-error">{error}</p>}

        <button type="submit" className="contact-submit" disabled={sending || sent}>
          {sending ? t('sending') : sent ? t('feedbackThanks') : t('sendFeedback')}
        </button>
      </form>

      {sent && (
        <div className="contact-sent-banner">
          <Icon name="check" size={16} /> {t('contactSuccessMessage')}
        </div>
      )}

      <div className="contact-info">
        <p className="contact-info-text">
          {t('orEmailUs')} <a href="mailto:hello@ykitesti.fi" className="contact-email-link">hello@ykitesti.fi</a>
        </p>
      </div>
    </div>
  );
};

export default ContactScreen;
